import { TrendDataScale } from '../../common/dashboards/models/TrendDataScale';
import { Moment } from 'moment';
import moment from 'moment/moment';
import { t } from 'i18next';
import { DateRange } from '@mui/x-date-pickers-pro';

export const extractTrendsDataScale = (dates: Moment[]) => {
  if (dates.length === 0) {
    return TrendDataScale.DAY;
  }

  const uniqueMonths = new Set<number>();
  const uniqueDays = new Set<number>();
  const uniqueHours = new Set<number>();
  const uniqueMinutes = new Set<number>();

  for (const date of dates) {
    uniqueMonths.add(date.month());
    uniqueDays.add(date.day());
    uniqueHours.add(date.hour());
    uniqueMinutes.add(date.minute());
  }

  if (uniqueMonths.size > 2) {
    return TrendDataScale.MONTH;
  } else if (uniqueDays.size > 2) {
    return TrendDataScale.DAY;
  } else if (uniqueHours.size > 2) {
    return TrendDataScale.HOUR;
  } else if (uniqueMinutes.size > 2) {
    return TrendDataScale.MINUTE;
  }
  return TrendDataScale.SECONDS;
};

export const formatRange = ([from, to]: DateRange<Moment>, scale = TrendDataScale.DAY, formatToToday = true) => {
  // If either value is null, just return formatted output for a single day.
  // In case when both are null, we just ignore everything.
  if (from === null || to === null) {
    return [from?.format('MMM Do, YYYY') || null, to?.format('MMM Do, YYYY') || null].filter((v) => v).join('');
  }

  switch (scale) {
    case TrendDataScale.MONTH:
      return [from.format('MMM YYYY'), to.format('MMM YYYY')].join(' - ');
    case TrendDataScale.HOUR: {
      const isSameDay = from.day() === to.day();
      if (isSameDay) {
        return from.format('MMM Do') + ', ' + [from.format('ha'), to.format('ha')].join(' - ');
      }

      return [from.format('MMM Do, ha'), to.format('MMM Do, ha')].join(' - ');
    }
    case TrendDataScale.MINUTE:
      return [from.format('hh:mma'), to.format('hh:mma')].join(' - ');
    case TrendDataScale.SECONDS:
      return [from.format('hh:mm:ssa'), to.format('hh:mm:ssa')].join(' - ');
    case TrendDataScale.DAY:
    default: {
      let fromDate = from.format('MMM Do');
      let toDate = to.format('MMM Do');
      if (to.format('YYYY-MM-DD') === moment().format('YYYY-MM-DD') && formatToToday) {
        toDate = t('today');
      }
      if (from.year() !== moment().year()) {
        fromDate = from.format('MMM Do YYYY');
      }
      if (to.year() !== moment().year()) {
        toDate = to.format('MMM Do YYYY');
      }

      return [fromDate, toDate].join(' - ');
    }
  }
};
